import React from 'react';
import { StyleSheet, css } from "../../styles/theme";
var styles = StyleSheet.create({
  badge: {
    fontSize: 12,
    "float": 'right',
    fontWeight: 'bold',
    fontFamily: 'OpenSans',
    width: 'fit-content',
    textDecoration: 'none',
    color: 'black',
    backgroundColor: 'var(--cds-color-yellow-200, #FFE057)',
    borderRadius: '10px',
    padding: '0px 15px',
    verticalAlign: 'middle'
  }
});
export default function TagBadge(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement("div", css('rc-TagBadge'), /*#__PURE__*/React.createElement("span", css(styles.badge), text));
}